import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton, Popover } from '@mui/material';
// mocks_
// import account from '../../../_mock/account';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: 'eva:home-fill',
  },
  {
    label: 'Profile',
    icon: 'eva:person-fill',
  },
  {
    label: 'Settings',
    icon: 'eva:settings-2-fill',
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const navigate = useNavigate();
  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {

    setOpen(null);

  };

   // *** Edwin
  const logOut = () => {
    localStorage.removeItem("mYLog");
    localStorage.removeItem("profileImage");
    localStorage.removeItem("displayName");
    localStorage.removeItem("userDetail");
    localStorage.removeItem("userId");
    setOpen(null);
    navigate('/login', { replace: true });
  };

  const [account, setUser] = useState([{}]);
  const [loginuserDetailId, setloginuserDetailId] = useState();
  const [userrole, setuserrole] = useState();
  const [userName, setuserName] = useState();
  const [userImage, setuserImage] = useState();

  const chkUserLogin = () => {
    const b = JSON.parse(localStorage.getItem('mYLog'));
    if (b === null) {
      navigate('/login11', { replace: true });
    }
    else {
      setuserName(JSON.parse(localStorage.getItem('mYLog')).displayName)
      setuserImage(JSON.parse(localStorage.getItem('mYLog')).ProfileImage)
      setloginuserDetailId(JSON.parse(localStorage.getItem('mYLog')).UId)
      setuserrole(JSON.parse(localStorage.getItem('mYLog')).role)
    }

  };


  useEffect(() => {
    chkUserLogin();
  }, []);
// *** End Edwin




  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={`/assets/images/avatars/${userImage}`} alt="photoURL" />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {account[0].displayName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {account[0].emailId}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={handleClose}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={logOut} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </Popover>
    </>
  );
}
